import React from "react";

function TextBox({ type = 'text', name, value, placeholder, onChange }) {
	return <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder} className='bg-[#4B4B4B] mb-4 p-3 ' />;
}

export default TextBox;
